import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import chart from './modules/chart'
import user from './modules/user'
import table from './modules/table'
import app from './modules/app'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    reducer: (state) => ({auth: state.auth})
})

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        auth,
        chart,
        user,
        app,
        table
    },
    plugins: [vuexLocal.plugin]
})
